import { LEGENDS } from "data/information"
import { ICheckbox } from "./props"
import { Container, Description, Error, Input, Label, Td, TdDescription } from "./styles"

const Checkbox = ({
  description,
  name,
  onChange,
  onBlur,
  error,
  value
}: ICheckbox) => {
  return (
    <Container>
      <TdDescription>
        <Description>{description}{error && <Error>?</Error>}</Description>
      </TdDescription>
      {LEGENDS.map((legend) => (
        <Td key={legend?.id}>
          <Label
            error={error}
            checked={value == legend?.id}
          >
            <Input
              type="radio"
              name={name}
              value={legend?.id}
              onChange={(e: any) => onChange?.(e.target.value)}
              onBlur={(e: any) => onBlur?.(e.target.value)}
              checked={value == legend?.id}
            />
          </Label>
        </Td>
      ))}
    </Container>
  )
}

Checkbox.defaultProps = {
  description: '',
  name: ''
}

export default Checkbox